import { combineReducers } from 'redux';
import shop from './shop';
import pricing from './pricing';
import businessUnit from './business-unit';
import analytics from './analytics';
import trustpilot from './trustpilot';
import businessModule from './businessModule';

export default combineReducers({
  shop, pricing, businessUnit, analytics, trustpilot, businessModule,
});
